import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { AlertTriangle } from "lucide-react";

interface TrfLabConfirmModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onCancel: () => void;
  onChangeLab: () => void;
  loading?: boolean;
  testDetails?: any;
}

const TrfLabConfirmModal: React.FC<TrfLabConfirmModalProps> = ({
  open,
  setOpen,
  onCancel,
  onChangeLab,
  loading = false,
  testDetails,
}) => {
  // const generateTRFButtonref = useRef(null);
  const changeLabButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        initialFocus={changeLabButtonRef}
        onClose={() => setOpen(false)}
      >
        <div className="flex items-end justify-center min-h-screen px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-xl overflow-hidden text-left shadow-2xl transform transition-all sm:my-8 sm:align-middle w-full sm:max-w-md">
              <div className="bg-[#F9FAFB] px-4 py-4 flex items-center justify-between border-b border-gray-100">
                <div className="flex items-center gap-2.5">
                  <div className="p-2 bg-yellow-100 rounded-xl">
                    <AlertTriangle className="w-5 h-5 text-yellow-600" />
                  </div>
                  <h2 className="text-base font-bold text-gray-900">
                    Confirm Destination Lab
                  </h2>
                </div>
                <button
                  type="button"
                  className="p-1.5 rounded-full bg-gray-100 hover:bg-gray-200 transition"
                  onClick={() => setOpen(false)}
                >
                  <XMarkIcon className="h-5 w-5 text-gray-600" />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <p className="text-xs text-gray-700 leading-relaxed">
                  Confirm the lab to generate the TRF, or change the lab before proceeding.
                </p>

                <div className="grid grid-row-2 gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100">
                  <div className="space-y-1">
                    <p className="text-xs font-semibold text-gray-500 tracking-wider">Lab Name</p>
                    <p className="text-base font-bold text-gray-900 line-clamp-1" title={testDetails?.lab_partner_name}>
                      {testDetails?.lab_partner_name || "NA"}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-xs font-semibold text-gray-500 tracking-wider">Test Name</p>
                    <p className="text-xs font-medium text-gray-900">
                      {testDetails?.test_name || "NA"}
                    </p>
                  </div>
                  
                </div>
              </div>

              <div className="px-4 py-4 bg-gray-50 border-t border-gray-100 flex gap-3">
                <button
                  type="button"
                  ref={changeLabButtonRef}
                  disabled={loading}
                  onClick={onChangeLab}
                  className="flex-1 px-4 py-2.5 text-xs font-bold rounded-xl transition-all bg-black text-white hover:bg-gray-800"
                >
                  Change Lab
                </button>

                <button
                  // ref={generateTRFButtonref}
                  type="button"
                  className="flex-1 px-4 py-2.5 text-xs font-bold  rounded-xl  transition text-gray-600 bg-white border border-gray-200  hover:bg-gray-100"
                  onClick={onCancel}
                >
                  Confirm
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default TrfLabConfirmModal;